import React, {useContext, useEffect, useState} from 'react';
import WorkScheduleWeek from "./work-schedule-week.jsx";
import {WorkScheduleContext} from "../context/work-schedule-context.jsx";
import {add, format} from "date-fns";
import Button from "../../../../../../../../components/button/button.jsx";
import clsx from "clsx";
import WorkScheduleService from "../../../../../../../../services/web/work-schedule-service.js";
import {FaTrash} from "react-icons/fa";
import {navigateHook} from "../../../../../../../../hooks/use-navigate.js";
const WorkScheduleWeekPreview = () => {
    const {startDate, endDate, previewTeams, removeItem, removeAll} = useContext(WorkScheduleContext);
    const [days, setDays] = useState([]);
    const navigate = navigateHook();

    useEffect(() => {
        const getWeekDaysFromDate = async () => {
            if(startDate && endDate){
                const {data} = await WorkScheduleService.getHolidays(format(startDate, "yyyy-MM-dd"), format(endDate, "yyyy-MM-dd"))
                const holidays = data ?? [];
                const daysOfWeek = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
                const weekDays = [];
                for (let i = 0; i < 7; i++) {
                    const currentDay = add(startDate, {days: i})
                    const dayIndex = currentDay.getDay();
                    const monthDay = currentDay.getDate();

                    const filter = holidays.filter(holiday => {
                        return holiday.date === format(currentDay, "yyyy-MM-dd");
                    });

                    const keysSet = new Set();
                    filter.forEach(obj => Object.keys(obj).forEach(key => keysSet.add(key)));

                    weekDays.push({
                        monthday: monthDay,
                        weekday: daysOfWeek[dayIndex],
                        numberWeekday: dayIndex,
                        completeDate: format(currentDay, 'yyyy-MM-dd'),
                        isHoliday: false,
                        holidays: []
                    });
                }

                setDays(weekDays)
            }
        }
        removeAll();
        getWeekDaysFromDate();
    }, [startDate, endDate])



    const openCalendar = () => {
        localStorage.setItem("calculated-schedules", JSON.stringify(previewTeams));
        if (startDate) localStorage.setItem("work-schedule-start-date", JSON.stringify(startDate.toISOString().split("T")[0]));
        navigate("/work-schedule/calendar", true);
    }

    return(
        <>
            { startDate && endDate ?
            <>
                <div className="flex flex-col w-full text-[#2E3742]">
                    <div className="flex space-around bg-[#E6E6E6] font-[800]">
                        <div className="w-[25%] text-start p-[3px] border border-[#ddd]"><span className="ms-2">Equipe</span></div>
                        {
                            days.map((day, index) => (
                                <div key={index} className={clsx("w-[10%] p-[3px] text-center border border-[#ddd]",
                                    {"bg-[#fee698]": day.isHoliday},
                                    {"bg-[#b6b1ff78]": day.numberWeekday === 0})}>
                                    {day.weekday + "(" + day.monthday + ") "}
                                </div>
                            ))
                        }
                        <div className="w-[5%] p-[3px] text-center border border-[#ddd]"></div>
                    </div>
                    {
                        previewTeams?.length > 0 ?
                            previewTeams.map((team, teamIndex) => (
                                <div key={teamIndex} className="flex">
                                    <div className="w-[25%] flex h-[40px] items-center border border-[#ebebeb] box-border">
                                        <div className="pl-[10px] overflow-hidden text-ellipsis whitespace-nowrap">{team.name}</div>
                                    </div>
                                    <WorkScheduleWeek days={days} schedules={team?.schedules} />
                                    <div className="w-[5%] h-[40px] flex items-center justify-center border border-[#ebebeb] box-border p-[4px] team-remove">
                                        <Button target="danger" className="!px-2" title="Excluir equipe" onClick={() => removeItem(team)} >
                                            <FaTrash/>
                                        </Button>
                                    </div>
                                </div>
                            )) :
                            <div className="flex">
                                <div className="w-[25%] flex h-[40px] items-center border border-[#ebebeb] box-border">
                                    <div className="pl-[10px] overflow-hidden text-ellipsis whitespace-nowrap"></div>
                                </div>
                                <WorkScheduleWeek days={days} schedules={[]} />
                                <div className="w-[5%] h-[40px] flex items-center justify-center border border-[#ebebeb] box-border">
                                </div>
                            </div>
                    }
                    {
                        previewTeams?.length > 0 &&
                        <div className="flex">
                            <div className="w-[25%] flex h-[40px] items-center border border-[#ebebeb] box-border">
                                <div className="pl-[10px] overflow-hidden text-ellipsis whitespace-nowrap"></div>
                            </div>
                            <WorkScheduleWeek days={days} schedules={[]} />
                            <div className="w-[5%] h-[40px] flex items-center justify-center border border-[#ebebeb] box-border">
                            </div>
                        </div>
                    }
                </div>
                <div className={"flex justify-between w-full mt-2"}>
                    <div className="text-start"><span className="italic">* Arraste um turno para o dia de início.</span></div>
                    <Button onClick={() => openCalendar()}>
                        Abrir calendário
                    </Button>
                </div>
            </> : <div className="flex justify-center items-center h-100 text-[#181d1f] text-[14px] h-full"><span>Preencha as datas para liberar a pré-visualização.</span></div> }
        </>
    )
}

export default WorkScheduleWeekPreview;